<template>
  <div class="map-view">
    <div class="mv-service" :class="{ 'mv-service--left': left }">
      <span class="s-label">当年服务总人次</span>
      <v-count class="s-number" :start-val="startNum" :end-val="endNum + this.$configer.serveData"></v-count>
    </div>

    <div ref="bmap" id="bmap" class="mv-bmap" />
    <!-- <v-chart class="mv-bmap" ref="bmap" :options="mapOption" autoresize /> -->

    <div class="mv-player" v-show="playerShow">
      <img class="p-close" src="../assets/images/icon_close.png" alt="#" @click="handleClosePlayer" />
      <div class="p-title">{{ playerTitle }}</div>
      <div class="p-swiper">
        <swiper ref="swiper" :options="swiperOption" @slideChange="onSildeChanged">
          <swiper-slide v-for="(item, index) in playerList" :key="index">
            <video-player class="vjs-custom-skin" :ref="'player' + index" :options="item.option"
              :playsinline="true"></video-player>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <!-- v-if="obj.name != '社区'" -->
    <el-checkbox-group v-model="typeData" class="mv-checkbox" :class="{ 'mv-checkbox--right': right }">
      <div class="checkbox-border" v-for="(obj, key) in typeMap" :key="key">
        <img v-if="obj.name == '街道'" class="checkbox-img" src="../assets/images/icon_dot4.png" alt="">
        <img v-else-if="obj.name == '社区'" class="checkbox-img" src="../assets/images/icon_dot3.png" alt="">
        <img v-else-if="obj.name == '服务组织'" class="checkbox-img" src="../assets/images/icon_dot1.png" alt="">
        <img v-else-if="obj.name == '老人'" class="checkbox-img" src="../assets/images/icon_dot7.png" alt="">
        <el-checkbox :label="key" :style="{ color: obj.color }" @change="onCheckboxChange($event, key)" checked>
          {{ obj.name }}（{{ obj.num }}）

        </el-checkbox>
      </div>
    </el-checkbox-group>
    <!-- <div class="map-bg" v-show="alermShow">
      <div class="alerm">
        <img src="../assets/images/icon_close.png" class="close-btn" @click="closeAlermtips" alt="">
        <div class="alerm-top">
          <img :src="alarmData.HeadImg" alt="">
          <div class="alerm-top-right">
            <p>{{ alarmData.ElderName }}</p>
            <p>{{ alarmData.ElderMobilePhone }}</p>
            <p>{{ alarmData.Position }}</p>
          </div>
        </div>
        <div class="alerm-bottom">
          {{ alarmData.AlertMsg }}
        </div>
      </div>
    </div> -->
    <el-dialog title="报警信息" :visible.sync="alermShow" class="alerm-pop" width="30%" center @closed="closeAlermtips">
      <div class="alerm">
        <!-- <img src="../assets/images/icon_close.png" class="close-btn" @click="closeAlermtips" alt=""> -->
        <div class="alerm-top">
          <img :src="alarmData.HeadImg" alt="">
          <!-- ../assets/images/photo.png -->
          <div class="alerm-top-right">
            <p>{{ alarmData.ElderName }}</p>
            <p>{{ alarmData.ElderMobilePhone }}</p>
            <p>{{ alarmData.Position }}</p>
          </div>
        </div>
        <div class="alerm-bottom">
          {{ alarmData.AlertMsg }}
        </div>
        <div>
          <div class="alerm-alarm">报警状态：
            <el-radio v-model="radio" label="1">已处理</el-radio>
            <el-radio v-model="radio" label="2">误报</el-radio>
            <el-radio v-model="radio" label="3">其他</el-radio>
          </div>
          <div class="alerm-alarm">处理意见：<el-input type="textarea" class="mt10" :rows="2" placeholder="请输入处理意见"
              v-model="textarea">
            </el-input></div>
          <div class="cuhli">
            <el-button type="primary" @click="alermT0Do(alarmData)">处理报警</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="elder.name" :visible.sync="elderDialog" width="30%" center>
      <div class="elder">长者性别：{{ elder.sex || "--" }}</div>
      <div class="elder">身份证号：{{ elder.IDNumber || "--" }}</div>
      <div class="elder">长者年龄：{{ elder.age || "--" }}</div>
      <div class="elder">联系方式：{{ elder.phone || "--" }}</div>
      <div class="elder">居住地址：{{ elder.address || "--" }}</div>
      <!-- <img  class="elder-img"  :key="key" :src="value" alt=""> -->
      <!-- <template v-for="(value, key) in elder.LSDevice"> -->
      <!-- <p>{{ value }}</p> -->
      <img class="elder-img" v-if="elder.LSDevice == '雷达'" src="../assets/images/ld.png" alt="">
      <img class="elder-img" v-else-if="elder.LSDevice == '红外'" src="../assets/images/hy.png" alt="">
      <img class="elder-img" v-else-if="elder.LSDevice == '手表'" src="../assets/images/sb.png" alt="">
      <img class="elder-img" v-else-if="elder.LSDevice == '摄像头'" src="../assets/images/sx.png" alt="">
      <!-- </template> -->
    </el-dialog>
    <audio class="audio" loop ref="audio" src="../assets/audio/alerm.wav"></audio>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VCount from 'vue-count-to'
import RippleOverlay from '@/utils/rippleOverlay'
import StyleJson from '@/assets/resources/bmap-style.json'
import { videoPlayer } from 'vue-video-player'
import 'videojs-contrib-hls.js/src/videojs.hlsjs'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'echarts/extension/bmap/bmap'

export default {
  name: 'MapView',
  components: {
    VCount,
    videoPlayer,
  },
  computed: {
    ...mapGetters(['cid', 'mapArea', 'mapCenter', 'userId',]),
    swiper: {
      get() {
        return this.$refs.swiper && this.$refs.swiper['swiper']
      },
      set() { },
    },
  },
  props: {
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      radio: '1',
      textarea: '',
      cancelElderData: null,
      dataInterval: null,
      elderInterval: null,
      startNum: 0,
      endNum: 0,
      keyword: '',
      bmap: null,
      chart: null,
      markerMap: {},
      elderMarkers: [],
      playerList: [],
      playerShow: false,
      playerTitle: '',
      swiperOption: {
        initialSlide: 0,
        speed: 1000,
        loop: false,
        observer: true,
        observeSlideChildren: true,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      mapOption: {
        bmap: {
          center: [],
          zoom: 10,
          roam: true,
          mapStyle: {
            styleJson: StyleJson,
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          triggerOn: 'click',
          alwaysShowContent: true,
          enterable: true,
          confine: true,
        },
        series: [
          {
            z: 10,
            type: 'scatter',
            name: '养老服务机构',
            coordinateSystem: 'bmap',
            symbolSize: 20,
            tooltip: {
              backgroundColor: 'transparent',
              formatter: (params) => {
                // console.log(params)
                const data = params.data
                const avatar = data.avatar
                const title = data.title || '-'
                const contact = data.contact || '-'
                const phone = data.phone || '-'
                const address = data.address || '-'
                const type = data.type || '-'
                const level = data.level || '-'
                const bedNum = data.bedNum || '-'
                const staffNum = data.staffNum || '-'
                const overview = data.overview || '-'
                return (
                  '<div id="v-tooltip">' +
                  '<span class="t-close" onclick="closeTooltip()"></span>' +
                  '<img class="t-avatar" src=' +
                  avatar +
                  ' alt="机构"/>' +
                  '<div class="t-info"><div>' +
                  title +
                  '</div><div><span class="t-label">联系人: </span>' +
                  contact +
                  '</div><div><span class="t-label">联系电话: </span>' +
                  phone +
                  '</div><div><span class="t-label">机构地址: </span> ' +
                  address +
                  '</div><div><span class="t-label">机构类型: </span> ' +
                  type +
                  '</div><div><span class="t-label">机构等级: </span> ' +
                  level +
                  '</div><div><span class="t-label">床位数量: </span> ' +
                  bedNum +
                  '张</div><div><span class="t-label">服务人员: </span>' +
                  staffNum +
                  '人</div><div><span class="t-label">服务概况: </span> ' +
                  overview +
                  '</div>' +
                  '</div>' +
                  '<img class="t-video" src="' +
                  require('@/assets/images/icon_video.png') +
                  '" onclick="showVideoPlayer(\'' +
                  data.gid +
                  "','" +
                  data.title +
                  '\');"/>' +
                  '</div>'
                )
              },
            },
            data: [],
          },
          {
            z: 20,
            type: 'effectScatter',
            name: '服务中老人',
            coordinateSystem: 'bmap',
            rippleEffect: {
              brushType: 'fill',
              period: 3,
              scale: 3,
            },
            symbolSize: 10,
            itemStyle: {
              color: '#00ff66',
            },
            tooltip: {
              backgroundColor: 'transparent',
              formatter: (params) => {
                const content = params.data.content
                return (
                  '<div id="v-tooltip">' +
                  '<span class="t-close" onclick="closeTooltip()"></span><div class="t-content">' +
                  content +
                  '</div> </div>'
                )
              },
            },
            data: [],
          },
        ],
        animation: false,
      },
      typeMap: {},
      typeData: [],
      typeList: [],
      typeColors: [
        '#8747fc',
        '#ffcc00',
        '#09b1ff',
        '#ee0000',
        '#8b4513',
        '#ff8787',
        '#0ccec7',
        '#ff1414',
        '#96ffec',
        '#fc01ff',
        '#a7ef1c',
        '#8b4513',
      ],
      alermInterval: null,
      alarmData: {
        HeadImg: require('../assets/images/photo.png'),
        ElderName: '长者姓名',
        ElderMobilePhone: '联系方式',
        Position: '长者居住地址',
        AlertMsg: '报警信息',
      },
      alermShow: false,
      elderDialog: false,
      elder: {
        tid: 8,
        cid: 'item.CheckDataId',
        lng: 0,
        lat: 0,
        name: '-',
        sex: '-',
        IDNumber: '-',
        age: '-',
        phone: '-',
        address: '-',
        equmentStatus: [],
      },
      organ: [],
      elderMarker: [],
      ImgInfoWindow: null
    }
  },
  created() {
    // 设置地图中心点
    this.mapOption.bmap.center = this.mapCenter
    // this.getOrganType(this.cid)
    this.getServiceTimes(this.cid)
    this.getAlermInfo(this.cid)

    window.closeInfoWindow = () => {
      this.closeInfoWindow()
    }
    window.showVideoPlayer = (gid, name) => {
      this.$api
        .getOrganMonitor(gid)
        .then((res) => {
          if (!res) return
          this.playerList = res.map((item) => ({
            option: {
              loop: false,
              muted: false,
              controls: true,
              autoplay: false,
              language: 'zh',
              preload: 'none',
              playbackRates: [0.5, 1, 1.5, 2],
              notSupportedMessage: '视频源错误, 暂时无法播放!',
              techOrder: ['html5'],
              html5: { hls: { withCredentials: false } },
              // flash: { swf: '../assets/resources/video-js.swf' },
              controlBar: {
                timeDivider: false,
                progressControl: true,
                fullscreenToggle: true,
                durationDisplay: false,
                remainingTimeDisplay: false,
              },
              sources: [
                {
                  withCredentials: false,
                  type: 'application/x-mpegURL',
                  src: item.Data,
                },
              ],
            },
          }))
          this.playerTitle = name
          this.playerShow = true
          this.closeInfoWindow()
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  mounted() {
    this.initBMap()
    this.getAllCheckElderInfoHasLongLat(this.cid)
    this.dataInterval = setInterval(() => {
      this.getServiceTimes(this.cid)
    }, this.$interval)
    this.alermInterval = setInterval(() => {
      this.getAlermInfo(this.cid)
    }, 5000)
    this.elderInterval = setInterval(() => {
      this.getElderData(this.cid, this)
    }, this.$interval)
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
    if (this.dataInterval) {
      clearInterval(this.dataInterval)
      this.dataInterval = null
    }
    if (this.elderInterval) {
      clearInterval(this.elderInterval)
      this.elderInterval = null
    }
  },
  watch: {
    alermShow(ndata) {
      PubSub.publish('alerm', ndata)
    }
  },
  methods: {
    closeAlermtips() {
      let that = this;
      that.alermShow = false
      that.$refs.audio.pause()
      this.radio = '1'
      this.textarea = ''
    },
    alermT0Do(data) {
      let that = this;
      let alertId = data.ID;
      let userId = that.userId;
      let stateID = that.radio;
      let remark = that.textarea;
      let ElderName = data.ElderName;
      if (remark == '') {
        return this.$message({
          type:'error',
          message:'请填写处理意见！'
        })
      }
      that.$api
        .dealSmartAlertInfo(alertId, userId, stateID, remark)
        .then((data) => {
          that.alermShow = false
          that.radio = '1'
          that.textarea = ''
          that.$message({
            message: ElderName + '报警已处理！',
            type: 'success'
          })
        })
        .catch((error) => {
          console.error(error)
        })
    },
    getAlermInfo(cid) {
      this.$api
        .getSmartAlertinfoTop1(cid)
        .then((result) => {
          if (!result || this.alarmData.flag == (result.AlertTime + result.ElderName)) return
          if (result.HeadImgPath) {
            result.HeadImg = this.$Ip + result.HeadImgPath
          } else {
            result.HeadImg = require('../assets/images/photo.png')
          }
          result.flag = result.AlertTime + result.ElderName
          this.alarmData = result
          this.alermShow = true
          this.$refs.audio.play()
        }).catch((err) => {
          console.log(err)
        });
    },
    handleSearchOrgan(keyword, callback) {
      let res = []
      if (!keyword.length) return callback(res)
      res = this.organList.filter((item) => item.name.indexOf(keyword) !== -1)
      console.log(res)
      callback(res)
    },
    handleSelectOrgan(organ) {
      const point = new BMapGL.Point(organ.lng, organ.lat)
      const infoWindow = this.createInfoWindow(organ, 'organ')
      // this.bmap.panTo(point)
      this.bmap.setCenter(point)
      this.bmap.openInfoWindow(infoWindow, point)
    },
    handleClosePlayer() {
      // 重置Swiper初始位置
      this.swiper.slideTo(0, 0, false)
      this.playerShow = false
      this.playerList = []
    },
    onCheckboxChange(checked, tid) {
      let markers
      if (tid === 'elder') {
        markers = this.elderMarkers
        if (checked) {
          markers.forEach((marker) => this.bmap.addOverlay(marker))
          this.elderInterval = setInterval(() => {
            this.getElderData(this.cid, this)
          }, this.$interval)
        } else {
          markers.forEach((marker) => this.bmap.removeOverlay(marker))
          this.cancelElderData && this.cancelElderData()
          if (this.elderInterval) {
            clearInterval(this.elderInterval)
            this.elderInterval = null
          }
        }
      } else {
        markers = this.markerMap[tid]
        if (checked) {
          markers && markers.forEach((marker) => this.bmap.addOverlay(marker))
        } else {
          markers && markers.forEach((marker) => this.bmap.removeOverlay(marker))
        }
      }
    },
    onSildeChanged() {
      // const curRef = 'player' + this.swiper.activeIndex
      // const curPlayer = this.$refs[curRef][0].player
      // curPlayer && curPlayer.play()
      const preRef = 'player' + this.swiper.previousIndex
      const prePlayer = this.$refs[preRef][0].player
      prePlayer && prePlayer.pause()
    },
    initBMap() {
      this.bmap = new BMapGL.Map('bmap', {
        enableMapClick: false,
      })
      // 地图初始化设置中心点后才能自定义地图样式(设置中心区域无效)
      this.bmap.centerAndZoom(new BMapGL.Point(118.57485, 32.16619), 13.5)
      this.bmap.enableScrollWheelZoom(true);
      // this.bmap.setHeading(90);
      this.bmap.setMapType(BMAP_EARTH_MAP);
      console.log(this.bmap.getTilt());
      this.bmap.enableScrollWheelZoom()
      this.bmap.setMapStyleV2({
        styleJson: StyleJson,
      })

      // 添加行政区划边界
      this.addAreaBoundary2(this.mapArea)
      // 获取机构数据
      this.getOrganData(this.cid)
      // 获取服务中数据
      this.getElderData(this.cid, this)
      // 获得当前定位城市
      new BMapGL.LocalCity().get((res) => {
        this.$emit('locate', {
          lat: res.center.lat,
          lng: res.center.lng,
        })
      })
    },
    initEMap() {
      this.chart = this.$refs.bmap.chart
      this.bmap = this.chart
        .getModel()
        .getComponent('bmap')
        .getBMap()
      this.bmap.setMapStyleV2({
        styleJson: StyleJson,
      })
      this.addAreaBoundary(this.mapArea)
      this.getOrganData(this.cid)
      this.getElderData(this.cid, this)
      new BMapGL.LocalCity().get((res) => {
        this.$emit('locate', {
          lat: res.center.lat,
          lng: res.center.lng,
        })
      })
    },
    addAreaBoundary(area) {
      let that = this;
      let bd = new BMapGL.Boundary();
      // 给某一个省 市 县 设置3d棱柱
      // bd.get("惠城区", function (rs) {
      let pointArray = [];
      let path = [];
      let str = that.$configer.yongning.replace(" ", "");
      let points = str.split(";");
      for (let j = 0; j < points.length; j++) {
        let lng = points[j].split(",")[0];
        let lat = points[j].split(",")[1];
        path.push(new BMapGL.Point(lng, lat));
      }
      let prism = new BMapGL.Prism(path, 800, {
        topFillColor: "#fff",
        topFillOpacity: 0.3,
        sideFillColor: "#aef2ff",
        sideFillOpacity: 0.9,
      });
      that.bmap.addOverlay(prism);
      pointArray = prism.getPath();
      that.bmap.setViewport(pointArray);
      this.bmap.setTilt(45);
      // });
    },
    addAreaBoundary3(area) {
      let that = this;
      var bd = new BMapGL.Boundary();
      // 给某一个省 市 县 设置3d棱柱
      bd.get("惠城区", function (rs) {
        console.log(rs);
        console.log(rs.boundaries.length);

        var count = rs.boundaries.length; //行政区域的点有多少个
        var pointArray = [];
        for (var i = 0; i < count; i++) {
          var path = [];
          var str = rs.boundaries[i].replace(" ", "");
          console.log(str);
          var points = str.split(";");
          for (var j = 0; j < points.length; j++) {
            var lng = points[j].split(",")[0];
            var lat = points[j].split(",")[1];
            path.push(new BMapGL.Point(lng, lat));
          }
          var prism = new BMapGL.Prism(path, 5000, {
            topFillColor: "#5679ea",
            topFillOpacity: 0.5,
            sideFillColor: "#5679ea",
            sideFillOpacity: 0.9,
          });
          that.bmap.addOverlay(prism);
        }
      });
    },
    addAreaBoundary2(area) {
      // const boundary = new BMapGL.Boundary(); // this.cityName
      let points = [];
      let boundary = [];
      // boundary.get(area, (rs) => {
      // if (!rs) return;
      boundary[1] = this.$configer.yongning
      boundary[0] = this.$configer.china
      // console.log(boundary[1]);
      let hole = new BMapGL.Polygon(boundary, {
        // strokeColor: "#aef2ff",
        strokeColor: "black",
        fillColor: 'black',
        fillOpacity: 0.8,
        // strokeStyle:"dashed",
        strokeStyle: "solid",
        strokeWeight: 1
      });
      // console.log(boundary[1]);
      let count = 1;
      if (boundary.length > 2) {
        for (let index = 1; index < boundary.length - 1; index++) {
          const element = boundary[index];
          console.log(element.length);
          if (element.length < boundary[index + 1].length) {
            count = index + 1;
          }
        }
      } else {
        count = 1
      }
      let Viewport = new BMapGL.Polygon(boundary[count], {
        strokeColor: "#aef2ff",
        fillColor: '#fff',
        fillOpacity: .2,
        strokeStyle: "solid",
        strokeWeight: 2
      });
      this.bmap.addOverlay(hole);
      points = Viewport.getPath();
      this.bmap.setViewport(points);
      // })
    },
    addAreaBoundary1(area) {
      const boundary = new BMapGL.Boundary()
      boundary.get(area, (res) => {
        if (!res) return
        let points = []
        res.boundaries.forEach((item) => {
          const polygon = new BMapGL.Polygon(item, {
            enableMassClear: false,
            strokeStyle: 'dashed',
            strokeWeight: 2,
            fillColor: '#fff',
            fillOpacity: 0.1,
          })
          this.bmap.addOverlay(polygon)
          points = points.concat(polygon.getPath())
        })
        this.bmap.setViewport(points)
      })
    },
    createOrganMarker(organ) {
      let that = this;
      let infoWindow = null;
      if (organ.tid != 7) {
        infoWindow = this.createInfoWindow(organ, 'organ');
      }
      const point = new BMapGL.Point(organ.lng, organ.lat)
      const image = require('@ast/images/icon_dot' + organ.tid + '.png')
      const icon = new BMapGL.Icon(image, new BMapGL.Size(20, 20), {
        imageOffset: new BMapGL.Size(0, 0),
      })
      const marker = new BMapGL.Marker(point, {
        icon: icon,
        enableMassClear: true,
      })
      // 设置Marker机构类型
      marker.tid = organ.tid
      marker.addEventListener('click', () => {
        if (organ.tid == 7) {
          that.getCheckElderDeviceState(organ.cid, organ)
        } else if (organ.tid == 1) {
          // marker.openInfoWindow(infoWindow, point)
          // console.log(organ);
          PubSub.publish('organ', organ)
        } else {
          marker.openInfoWindow(infoWindow, point)
        }
      })
      return marker
    },
    createElderMarker(elder) {
      const infoWindow = this.createInfoWindow(elder, 'elder')
      const point = new BMapGL.Point(elder.lng, elder.lat)
      const marker = new RippleOverlay(point, {
        width: 10,
        height: 10,
        color: '#00ff66',
        click: () => {
          this.bmap.openInfoWindow(infoWindow, point)
        },
      })
      return marker
    },
    createImgInfoWindow(data) {
      let infoWindow = `<div class="ImgInfoWindow">
          <img src="${process.env.VUE_APP_BASE_URL + data.photos[0]}" alt=""/>
        </div>`
      return new BMapGL.InfoWindow(infoWindow, {
        width: 0,
        height: 0,
        enableCloseOnClick: false
      })
    },
    createInfoWindow(data, type) {
      let infoWindow = ''
      if (type === 'organ') {
        const organImage = data.image ? process.env.VUE_APP_BASE_URL + data.image : require('@ast/images/img_organ.png')
        const organMonitor = data.monitors
          ? '<img class="t-video" src="' +
          require('@/assets/images/icon_video.png') +
          '" onclick="showVideoPlayer(\'' +
          data.cid +
          "','" +
          data.name +
          '\');"/>'
          : ''
        infoWindow =
          '<div class="t-content"><div class="t-title">' +
          data.name +
          '</div><div class="t-close" onclick="closeInfoWindow()"></div><div class="t-wrapper">' +
          '<img class="t-image" src=' +
          organImage +
          ' alt="机构" /><div class="t-info"><div><span class="t-label">机构类型：</span>' +
          data.type +
          '</div><div><span class="t-label">机构等级：</span>' +
          data.rank +
          '</div><div><span class="t-label">服务人员：</span>' +
          data.staff +
          '</div><div><span class="t-label">联系人：</span>' +
          data.linkman +
          '</div><div><span class="t-label">联系电话：</span>' +
          data.contact +
          '</div><div><span class="t-label">机构地址：</span>' +
          data.address +
          '</div></div>' +
          organMonitor +
          '</div></div>'
      } else if (type === 7) {
      } else {
        const contact = data.phone ? `(${data.phone})` : ''
        infoWindow =
          '<div><div class="t-close" onclick="closeInfoWindow()"></div><div class="t-desc">服务人员' +
          data.staff +
          contact +
          '正在对老人' +
          data.name +
          '进行' +
          data.service +
          '服务!</div></div>'
      }
      return new BMapGL.InfoWindow(infoWindow, {
        width: 0,
        height: 0,
      })
    },
    closeInfoWindow() {
      this.bmap.closeInfoWindow()
      // document.querySelector('.BMap_pop').style.display = 'none'
    },
    getOrganType() {
      this.$api
        .getOrganType()
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return
          data.forEach((item) => {
            const tid = Number(item.Value)
            this.typeMap[tid] = {
              num: 0,
              name: item.Name,
              color: this.typeColors[tid],
            }
            // this.typeData.push(item.Value)
            // this.typeList.push({
            //   name: item.Name,
            //   color: this.typeColors[tid],
            // })
          })
        })
        .catch((error) => {
          console.error(error)
        })
    },
    getOrganData(cid) {
      this.$api
        .getOrganData(cid)
        .then((res) => {
          if (!res || !res.length) return
          if (this.ImgInfoWindow) {
            clearInterval(this.ImgInfoWindow)
          }
          let typeMap = {}
          let organArray = []
          for (let item of res) {
            if (!item.Long || !item.Lat) continue
            const tid = item.CompanyTypeValue < 10000 ? item.CompanyTypeValue : 11
            if (!this.markerMap[tid]) {
              this.markerMap[tid] = []
              typeMap[tid] = {
                num: 0,
                name: item.CompanyTypeName,
                color: this.typeColors[tid],
              }
            }

            const organ = {
              tid: tid,
              cid: item.SysCompanyId,
              lng: Number(item.Long),
              lat: Number(item.Lat),
              name: item.CompanyName,
              image: item.CompanyImg,
              type: item.CompanyTypeName || '-',
              rank: item.SysCompanyLevel || '-',
              staff: item.EmployeeCount || '-',
              contact: item.ComHPerPhone || '-',
              linkman: item.ComHandlePerson || '-',
              address: item.CompanyAddress || '-',
              monitors: item.Monitors.length > 0,
              monitors: item.Monitors.length > 0,
              photos: item.CompanyPhotos,
            }
            // if (organ.type != '社区') {
            const marker = this.createOrganMarker(organ)
            this.bmap.addOverlay(marker)
            this.markerMap[tid].push(marker)
            typeMap[tid].num++
            // }
            if (organ.type == '服务组织' && organ.photos.length > 0) {
              organArray.push(organ)
            }
          }
          this.organ = organArray
          let length = this.organ.length
          let index = 0
          this.ImgInfoWindow = setInterval(() => {
            const point = new BMapGL.Point(this.organ[index].lng - 0.01, this.organ[index].lat - 0.007)
            this.bmap.openInfoWindow(this.createImgInfoWindow(this.organ[index]), point)
            if (index != length - 1) {
              index++
            } else {
              index = 0
            }

          }, 10000)

          this.typeMap = { ...typeMap, ...this.typeMap }
          // console.log(this.typeMap, this.markerMap)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getElderData(cid, cancel) {
      // 取消上一次请求
      this.cancelElderData && this.cancelElderData()
      this.$api
        .getElderData(cid, cancel)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return
          if (this.elderMarkers.length > 0) {
            this.elderMarkers.forEach((marker) => this.bmap.removeOverlay(marker))
          }
          let elderMarkers = []
          for (let item of data) {
            if (!item.BeginLong || !item.BeginLat) continue
            const marker = this.createElderMarker({
              lng: Number(item.BeginLong),
              lat: Number(item.BeginLat),
              avatar: item.HeadImgPath,
              name: item.ElderName,
              phone: item.EmployeeTel,
              staff: item.EmployeeName,
              service: item.ItemName,
            })
            this.bmap.addOverlay(marker)
            elderMarkers.push(marker)
          }
          this.elderMarkers = elderMarkers
          // 多选框添加服务中老人信息
          if (this.typeMap['elder']) {
            this.typeMap['elder'].num = data.length
          } else {
            this.typeMap['elder'] = {
              num: data.length,
              name: '服务中老人',
              color: '#00ff66',
            }
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    getServiceTimes(cid, type = '') {
      this.$api
        .getServiceTimes(cid, type)
        .then((data) => {
          if (!data) return
          this.startNum = this.endNum
          this.endNum = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
    getAllCheckElderInfoHasLongLat(cid) {
      this.$api
        .getAllCheckElderInfoHasLongLat(cid)
        .then((data) => {
          if (!data) return
          let markers = []
          let typeMap = {}
          const tid = 7
          for (let index = 0; index < data.length; index++) {
            const item = data[index];
            if (!this.markerMap[tid]) {
              this.markerMap[tid] = []
              typeMap[tid] = {
                num: 0,
                name: '老人',
                color: this.typeColors[tid],
              }
            }
            
            const organ = {
              tid: 7,
              cid: item.CheckDataId,
              lng: Number(item.BeginLong),
              lat: Number(item.BeginLat),
              name: item.ElderName || '-',
              sex: item.ElderSex || '-',
              IDNumber: item.ElderIDNumber || '-',
              age: item.ElderAge || '-',
              phone: item.ElderMobilePhone || '-',
              address: item.ElderAddress || '-',
              LSDevice: item.LSDevice,
            }
            const marker = this.createOrganMarker(organ);
            this.bmap.addOverlay(marker);
            this.markerMap[tid].push(marker)
            typeMap[tid].num++
          }
          this.elderMarker = markers
          this.typeMap = { ...typeMap, ...this.typeMap }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    getCheckElderDeviceState(cid, elder) {
      this.$api
        .getCheckElderDeviceStateYN(cid)
        .then((data) => {
          if (!data) return
          data = data.map(item => {
            return item
          })
          this.elder = elder
          this.elder.equmentStatus = data
          this.elderDialog = true

        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox-border {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 5px;

  img {
    margin-right: 10px;
  }
}

.checkbox-img {
  width: 15px;
  height: 15px;
}

.alerm-alarm {
  font-size: 16px;
  color: #fff;
  line-height: 1.25;
  margin-bottom: 15px;
}

.elder {
  width: 100%;
  line-height: 1.25;
  font-size: 16px;
  color: #fff;
  margin-bottom: 10px;
}

.elder-img {
  width: 43px;
  height: auto;
  margin-right: 15px;
  margin-top: 10px;
}

.map-bg {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(210, 210, 210, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.alerm {
  align-self: center;
  width: 100%;
  display: inline-block;
  position: relative;
  z-index: 9999;
  padding: 20px;
  color: #fff;
  // background: rgba(7, 13, 53, 0.8) url('../assets/images/bg_tooltip1.png') no-repeat center/100% 100%;

  .close-btn {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
  }

  &-bottom {
    width: calc(100%);
    // height: 100px;
    background-color: rgba(254, 80, 3, 0.7);
    padding: 5px;
    margin-bottom: 20px;
  }

  &-top {
    height: 100px;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;

    img {
      width: 80px;
      height: 80px;
      align-self: center;
    }

    &-right {
      align-self: center;
      width: calc(100% - 100px);
      height: 80px;
      // background-color: red;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
  }
}

.map-view {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 1px;
  display: flex;
  flex-direction: column;
  background: url(../assets/images/bg_view.png) no-repeat center/100% 100%;

  .mv-service {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 10px;
    left: 510px;
    height: 7vh;
    padding: 0 20px;
    transition: all 0.5s;
    background: url(../assets/images/bg_service.png) no-repeat center/100% 100%;

    &--left {
      left: 10px;
    }

    .s-label {
      font-family: 'FZ-ZZH';
      font-size: 22px;
      color: #39e9ff;
    }

    .s-number {
      margin-left: 15px;
      letter-spacing: 5px;
      font-family: 'Arial';
      font-style: italic;
      font-weight: bold;
      font-size: 36px;
      color: #00fc3a;
      // background: url('../assets/images/bg_digit.png') repeat-x 0 0/32px 40px;
    }
  }

  .mv-bmap {
    width: 100%;
    height: 100%;
  }

  .mv-player {
    z-index: 100;
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);

    &:hover {
      .p-close {
        visibility: visible;
      }
    }

    .p-close {
      z-index: 100;
      position: absolute;
      top: 45px;
      right: 5px;
      width: 20px;
      height: 20px;
      visibility: hidden;
      cursor: pointer;
    }

    .p-title {
      display: inline-block;
      height: 40px;
      padding: 0 20px;
      min-width: 100px;
      line-height: 45px;
      font-family: 'FZ-ZZH';
      font-size: 20px;
      color: #fff;
      background: url('../assets/images/bg_service.png') no-repeat center/100% 100%;
    }

    .p-swiper {
      width: 600px;
      height: 400px;
      padding: 1px;
      // margin-top: -2px;
      // border-radius: 10px;
      background: url('../assets/images/bg_tooltip.png') no-repeat center/100% 100%;

      .swiper-container {
        width: 100%;
        height: 100%;
      }

      .swiper-pagination {
        // bottom: 50px;
        left: 50%;
        width: auto;
        transform: translateX(-50%);
      }

      ::v-deep .swiper-pagination-bullet {
        background-color: #fff;

        &.swiper-pagination-bullet-active {
          background-color: #007aff;
        }
      }

      .video-player {
        width: 100%;
        height: 100%;

        ::v-deep .video-js {
          height: 100%;
          padding-top: 0;
          // border-radius: 10px;
        }
      }
    }
  }

  .mv-legend {
    position: absolute;
    right: 510px;
    bottom: 10px;
    padding: 15px;
    transition: all 0.5s;
    background: url('../assets/images/bg_view.png') no-repeat center/100% 100%;

    &--right {
      right: 10px;
    }

    li {
      font-family: 'FZ-ZZH';
      font-size: 16px;
      color: #fff;

      +li {
        margin-top: 10px;
      }

      img {
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }

      span {
        display: inline-block;
        vertical-align: middle;
        line-height: 1;
      }
    }
  }

  .mv-search {
    position: absolute;
    top: 10px;
    right: 510px;
    width: 250px;
    height: 50px;
    margin-top: 10px;
    font-size: 16px;
    transition: all 0.5s;

    &--right {
      right: 10px;
    }

    ::v-deep .el-input__inner {
      // font-size: 16px;
      color: #fff;
      border-radius: 5px;
      border: 1px solid #0069c3;
      background-color: rgba(210, 210, 210, 0.15);
    }
  }

  .mv-checkbox {
    position: absolute;
    right: 510px;
    top: 12px;
    padding: 10px;
    transition: all 0.5s;
    background: url('../assets/images/bg_view.png') no-repeat center center / 100% 100%;
    z-index: 9;

    &--right {
      right: 10px;
    }

    .el-checkbox {
      display: block;
      margin-right: 0;

      +.el-checkbox {
        margin-top: 10px;
      }

      ::v-deep .el-checkbox__input,
      ::v-deep .el-checkbox__label {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
      }

      &.is-checked ::v-deep .el-checkbox__label {
        color: inherit;
      }
    }
  }
}
</style>
